import { MINUTE_STEPS } from './constants';

export const toParts = (value: number) => {
  const hours = Math.floor(value / 60);
  return {
    hours,
    hours12: hours % 12 || 12,
    minutes: value % 60,
    period: hours < 12 ? 'AM' : 'PM',
  } as const;
};

export const fromParts12 = (hours12: number, minutes: number, period: 'AM' | 'PM') =>
  ((hours12 % 12) + (period === 'PM' ? 12 : 0)) * 60 + minutes;

export const getMinuteOptions = (current: number) =>
  MINUTE_STEPS.includes(current) ? MINUTE_STEPS : [...MINUTE_STEPS, current].sort((a, b) => a - b);

export const pad = (value: number) => String(value).padStart(2, '0');
